/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { DataWarehouseProductDTO } from "../models";
import { DataWarehouseProductDTOFromJSON, DataWarehouseProductDTOToJSON } from "../models";

export interface GetDataWarehouseProductDataRequest {
  searchQuery: string;
}

export interface GetDataWarehouseProductDataByEan13Request {
  ean13: string;
}

/**
 *
 */
export class DataWarehouseProductApi extends runtime.BaseAPI {
  /**
   */
  async getDataWarehouseProductDataRaw(
    requestParameters: GetDataWarehouseProductDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<DataWarehouseProductDTO>>> {
    if (requestParameters.searchQuery === null || requestParameters.searchQuery === undefined) {
      throw new runtime.RequiredError(
        "searchQuery",
        "Required parameter requestParameters.searchQuery was null or undefined when calling getDataWarehouseProductData."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/dealAlerts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DataWarehouseProductDTOFromJSON));
  }

  /**
   */
  async getDataWarehouseProductData(
    requestParameters: GetDataWarehouseProductDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<DataWarehouseProductDTO>> {
    const response = await this.getDataWarehouseProductDataRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getDataWarehouseProductDataByEan13Raw(
    requestParameters: GetDataWarehouseProductDataByEan13Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DataWarehouseProductDTO>> {
    if (requestParameters.ean13 === null || requestParameters.ean13 === undefined) {
      throw new runtime.RequiredError(
        "ean13",
        "Required parameter requestParameters.ean13 was null or undefined when calling getDataWarehouseProductDataByEan13."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/dealAlerts/{ean13}`.replace(`{${"ean13"}}`, encodeURIComponent(String(requestParameters.ean13))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => DataWarehouseProductDTOFromJSON(jsonValue));
  }

  /**
   */
  async getDataWarehouseProductDataByEan13(
    requestParameters: GetDataWarehouseProductDataByEan13Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DataWarehouseProductDTO> {
    const response = await this.getDataWarehouseProductDataByEan13Raw(requestParameters, initOverrides);
    return await response.value();
  }
}
